/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-notification': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M9.83 20.489c.725.003 1.45.005 2.175.005h7.561c.99-.001 1.632-.713 1.379-1.617-.122-.436-.375-.865-.665-1.228-.868-1.083-1.613-2.228-1.984-3.543a38.171 38.171 0 0 1-.877-3.739c-.428-2.432-2.573-4.264-5.21-4.363-2.598-.098-4.943 1.576-5.514 3.961-.095.4-.165.806-.235 1.211-.057.333-.114.666-.186.995-.4 1.844-1.044 3.591-2.274 5.11l-.041.051c-.3.37-.607.75-.804 1.168-.47 1.004.17 2.032 1.393 2.009 1.76-.034 3.52-.027 5.281-.02zm1.74 3.467l.164.044h.552l.146-.042c.102-.03.205-.06.308-.087.949-.257 1.553-.85 1.853-1.722.053-.155.074-.319.096-.486.01-.078.02-.156.034-.234H9.335c-.074 1.054.748 2.109 1.875 2.429l.358.098z" _fill="#CBD4D8"/>'
  }
})
